import { Routes } from '@angular/router';
import { authGuard } from '../auth/auth.guard';
import { marketplaceProfileGuard } from '../auth/marketplace-profile.guard';
import { LoadsListComponent } from './loads-list/loads-list.component';
import { LoadDetailsComponent } from './load-details/load-details.component';
import { CreateLoadComponent } from './create-load/create-load.component';

export const LOAD_ROUTES: Routes = [
  {
    path: 'loads',
    component: LoadsListComponent,
    canActivate: [authGuard, marketplaceProfileGuard]
  },
  {
    path: 'load/create',
    component: CreateLoadComponent,
    canActivate: [authGuard, marketplaceProfileGuard]
  },
  {
    path: 'load-details',
    component: LoadDetailsComponent,
    canActivate: [authGuard, marketplaceProfileGuard]
  },
  {
    path: 'load-details/:id',
    component: LoadDetailsComponent,
    canActivate: [authGuard, marketplaceProfileGuard]
  },
  {
    path: 'load-details/:id/find-availabilities',
    loadComponent: () => import('./find-availabilities/find-availabilities.component').then(m => m.FindAvailabilitiesComponent),
    canActivate: [authGuard, marketplaceProfileGuard]
  }
];
